import { ReactNode, createContext, useContext } from 'react';

const FieldErrorContext = createContext(false);

interface FieldErrorProviderProps {
  children: ReactNode;
  hasError: boolean;
}

export const FieldErrorProvider = ({ children, hasError }: FieldErrorProviderProps) => (
  <FieldErrorContext.Provider value={hasError}>{children}</FieldErrorContext.Provider>
);

export const useFieldError = () => useContext(FieldErrorContext);
